// extracted by mini-css-extract-plugin
export var chip = "_d4-0";
export var filterDropdown = "_d4-5";
export var filterItem = "_d4-6";
export var icon = "_d4-1";
export var removeButton = "_d4-3";
export var removeIcon = "_d4-4";
export var separator = "_d4-2";